import Chart from './chart.js';

nn.component.Chart = Chart;
